import {getHostname, getIsLocalDevelopmentHost} from '../../util/host';

const BOT_NAME_PRODUCTION = 'rocket_data_bot';
const BOT_NAME_PREPRODUCTION = 'rocket_data_preprod_bot';

// The analytics bot is registered per backend, so its name differs by environment:
// prod (go.rocketdata.io) = rocket_data_bot, preprod (*.space) = rocket_data_preprod_bot.
// On a local dev host the app is served locally but talks to a real backend via the dev proxy
// (API_URL), so fall back to API_URL.
function getTelegramAnalyticsBotName(): string {
    const target = getIsLocalDevelopmentHost() ? process.env.API_URL || '' : getHostname();

    return target.includes('.space') ? BOT_NAME_PREPRODUCTION : BOT_NAME_PRODUCTION;
}

export const telegramAnalyticsBotName = getTelegramAnalyticsBotName();
